<template>
    <div>
        <div v-if="status?.decommissionedAt && showDecommissioned">
            <span>
                {{ trans('general.status.decommissioned') }}
                <span class="text-nowrap">{{ formatDate(status?.decommissionedAt) }}</span>
            </span>
        </div>
        <div v-else>
            <span>
                {{ trans('general.status.last_tested') }}
                <br v-if="multiline" />
                <span :class="{ 'text-danger': status?.isTestOverdue }" class="text-nowrap">{{ formatDate(status?.lastPerformedTestAt) }}</span>
            </span>
        </div>
    </div>
</template>
<script>
import { DateTime } from 'luxon';

export default {
    props: {
        multiline: {
            type: Boolean,
            default: false,
        },
        status: {},
        // Optional asset timezone (TimezoneResource shape: { identifier, name }).
        // When set, dates render in this zone — matching the tasks list, which
        // freezes time in the asset's local frame instead of the browser's.
        timezone: {
            type: Object,
            default: null,
        },
        showDecommissioned: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        formatDate(date) {
            let dateObj = DateTime.fromISO(date);

            // Check if date is valid
            if (!dateObj || !dateObj.isValid) {
                return this.trans('general.not_available');
            }

            const zone = this.timezone?.identifier;
            if (zone) {
                dateObj = dateObj.setZone(zone);
            }
            dateObj = dateObj.setLocale(this.currentLocale);

            const now = zone ? DateTime.now().setZone(zone) : DateTime.local();
            if (dateObj.hasSame(now, 'day')) {
                return this.trans('general.today') + ', ' + dateObj.toLocaleString(DateTime.TIME_24_SIMPLE);
            } else {
                return dateObj.toLocaleString(DateTime.DATETIME_MED);
            }
        },
    },
};
</script>
